import {LEGACY_TO_NEW_ROUTE_MAP} from './legacy-to-new-route-map'
import {normalizeNavPath} from './normalize-nav-path'

export function resolveNewPortalPath(legacyPath: string) {
  const normalized = normalizeNavPath(legacyPath)
  return LEGACY_TO_NEW_ROUTE_MAP[normalized] ?? normalized
}
